import gql from 'graphql-tag';

export const PULL_GROUPS_SUMMARY = gql`
  query GroupsSummary($input: BPFReportGroupsSummaryInput!) {
    bpf {
      report {
        result: pullGroupsSummary(input: $input) {
          error
          success
          entity {
            groups {
              key
              name
              voCount
              invoiceSum
            }

            summary {
              data {
                stageId
                dealsSum
                stageName
                department
                dealsAmount
              }

              dealsSum
              dealsAmount
            }

            pagination {
              page
              total
              perPage
              totalPages
            }
          }
        }
      }
    }
  }
`;
